import React from "react";

const FormGroupAdapter = ({ input, inputOnChange, placeholder, meta, buttonLabel }: any) => {
  const inputProps = {
    ...input,
    onChange: (e: any) => {
      input.onChange(e) //needed to make the number port form work
      inputOnChange(e);
    },
  };

  let label='Upload Form'
  if(buttonLabel){
    label=buttonLabel
  }

  const id = inputProps.name+'-file-upload'

  return (
    <>
      <label htmlFor={id} className="custom-file-upload">
        {label}
      </label>

      <input
        {...inputProps}
        type="file"
        placeholder={placeholder}
        id={id}
      />
      {meta.error && meta.touched && (
        <span className="invalid">{meta.error}</span>
      )}
      {meta.valid && meta.dirty && <span className="valid">Great!</span>}
    </>
  )
}

export default FormGroupAdapter;
